import { Typography } from "@mui/material";
import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SearchIcon from '@mui/icons-material/Search';
import { CircularProgress, Tooltip, Select, MenuItem, FormControl, InputAdornment, TextField, Button, TableContainer, Table, TableHead, TableBody, Paper, TablePagination, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Box, FormHelperText } from '@mui/material';
import { styled } from '@mui/material/styles';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { post } from '../../../services/http';
import { ContextSession } from "../../../services/ContextSession";
import FilterListIcon from '@mui/icons-material/FilterList';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import IconButton from '@mui/material/IconButton';
import Popover from '@mui/material/Popover';

async function getSolicitudes(accesos, ip) {
    let json = { data: "null" };
    let url = "https://be.injupemp.gob.hn:8443/api/resumen/";
    //let url = "http://172.20.7.10:8082/api/resumen/";

    let auto = "Bearer " + accesos;

    let datas = await post(url, json, auto);
    //console.log("LA DATA DE LA TABLA ES: ", datas);
    return datas;
};

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: '#19438C',
        color: 'white',
        fontSize: 16,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
        borderRight: 'none', // Elimina la línea vertical entre columnas
        borderLeft: 'none', // Elimina la línea vertical entre columnas
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
    '&:hover': { // Agrega estilo al pasar el cursor sobre la fila
        backgroundColor: '#C1C1C1', // Cambia el color de fondo al pasar el cursor
    },
}));

function EstadosPreanalisis() {
    let sessi = useContext(ContextSession);
    const [page, setPage] = useState(0);
    const [loading, setLoading] = useState(true);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [searchTerm, setSearchTerm] = useState('');
    const [loanType, setLoanType] = useState('');
    const [statusFilter, setStatusFilter] = useState('');
    const [statusSolicitudFilter, setStatusSolicitudFilter] = useState('');
    const [filas, setFilas] = useState([]);

    useEffect(() => {
        async function fetchData() {
            try {
                let token = sessi.sessionData.token;
                const data = await getSolicitudes(token, sessi.ip);

                if (data) {
                    // Ordenar las filas
                    const sortedData = data.sort((a, b) => {
                        // Primero, ordenar por estado
                        if (a.asignado === null && b.asignado !== null) {
                            return -1; // 'Sin Asignar' debe ir antes que 'Asignado'
                        }
                        if (a.asignado !== null && b.asignado === null) {
                            return 1;
                        }
                        // Luego, ordenar por fecha de solicitud (más antigua primero)
                        return new Date(a.FechaSolicitud) - new Date(b.FechaSolicitud);
                    });
                    setFilas(sortedData);
                } else {
                    console.error('Error al obtener datos: datos no disponibles');
                }
            } catch (error) {
                console.error('Error al obtener datos:', error);
            } finally {
                setLoading(false);
            }
        }
        fetchData();
    }, [sessi.sessionData.token, sessi.ip]);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    // Reiniciar la página al cambiar el término de búsqueda
    const handleSearchChange = (event) => {
        const searchTerm = event.target.value;
        setSearchTerm(searchTerm);
        setPage(0); // Reinicia la página a la primera
    };

    const handleLoanTypeChange = (event) => {
        setLoanType(event.target.value);
    };

    const handleStatusChange = (event) => {
        setStatusFilter(event.target.value);
    };

    const handleStatusSolicitudChange = (event) => {
        setStatusSolicitudFilter(event.target.value);
    };

    const filteredRows = filas
    .filter((row) => {
        // Determina el estado de la solicitud
        const status = row.aprobado === 1 ? 'Pre Aprobado' :
            row.aprobado === 2 ? 'Pre Aprobado Sujeto A Cambios' :
                row.aprobado === 3 ? 'Rechazado' :
                    row.aprobado === 6 ? 'Rechazado' :
                        row.aprobado === 7 ? 'Aprobado Sujeto A Cambios' :
                            'Sin Revisar';

        // Determina si la solicitud está asignada o no
        const asignadoStatus = row.asignado !== null ? 'Asignado' : 'Sin Asignar';

        // Normaliza valores para búsqueda insensible a mayúsculas/minúsculas
        const lowerCaseSearchTerm = searchTerm.toLowerCase();

        return (
            (row.TipoPrestamo?.includes(loanType) || loanType === '') &&
            (status === statusSolicitudFilter || statusSolicitudFilter === '') &&
            (asignadoStatus === statusFilter || statusFilter === '') &&
            (
                searchTerm === '' ||
                (searchTerm && (
                    row.NumeroSolicitud?.toString().toLowerCase().includes(lowerCaseSearchTerm) ||
                    (row.solicitante && row.solicitante[0] && (
                        row.solicitante[0].Nombres?.toLowerCase().includes(lowerCaseSearchTerm) ||
                        row.solicitante[0].Apellidos?.toLowerCase().includes(lowerCaseSearchTerm)
                    ))
                ))
            )
        );
    })
    .sort((a, b) => new Date(b.FechaSolicitud) - new Date(a.FechaSolicitud)); // Ordenar por fecha descendente

    const [anchorEl, setAnchorEl] = useState(null);
    const [filterType, setFilterType] = useState('');

    const handleFilterClick = (event, type) => {
        setAnchorEl(event.currentTarget);
        setFilterType(type);
    };

    const handleFilterClose = () => {
        setAnchorEl(null);
        setFilterType('');
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    return (
        <div className="container" style={{ marginTop: 10 }}>
            {loading ? (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '200px' }}>
                    <CircularProgress />
                </div>
            ) : (
                <>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: 10 }}>
                        <h2><b>Estados Solicitudes de Preanálisis de Préstamos en INJUPEMP Conectados</b></h2>
                    </div>

                    <div className="row" style={{ marginTop: '20px' }}>
                        <TableContainer component={Paper}>
                            <Table>
                                <TableHead>
                                    <StyledTableRow>
                                        <StyledTableCell style={{ textAlign: 'center' }}>#</StyledTableCell>
                                        <StyledTableCell >
                                            <div>
                                                <strong>No. Solicitud</strong>
                                                <Tooltip title="Buscar por Solicitud" arrow>
                                                    <IconButton onClick={(event) => handleFilterClick(event, 'search')}>
                                                        <ManageSearchIcon style={{ color: 'white' }} />
                                                    </IconButton>
                                                </Tooltip>
                                            </div>
                                        </StyledTableCell>
                                        <StyledTableCell>
                                            <div>
                                                <strong>Nombre del Solicitante</strong>
                                                <Tooltip title="Buscar por Nombre" arrow>
                                                    <IconButton onClick={(event) => handleFilterClick(event, 'search')}>
                                                        <ManageSearchIcon style={{ color: 'white' }} />
                                                    </IconButton>
                                                </Tooltip>
                                            </div>
                                        </StyledTableCell>
                                        <StyledTableCell>
                                            <div>
                                                <strong>Tipo De Préstamo</strong>
                                                <Tooltip title="Filtrar por Tipo" arrow>
                                                    <IconButton onClick={(event) => handleFilterClick(event, 'loanType')}>
                                                        <FilterListIcon style={{ color: 'white' }} />
                                                    </IconButton>
                                                </Tooltip>
                                            </div>
                                        </StyledTableCell>
                                        <StyledTableCell>
                                            <strong>Fecha Solicitud</strong>
                                        </StyledTableCell>
                                        <StyledTableCell>
                                            <div>
                                                <strong>Analista</strong>
                                                <Tooltip title="Filtrar por Analista" arrow>
                                                    <IconButton onClick={(event) => handleFilterClick(event, 'status')}>
                                                        <FilterListIcon style={{ color: 'white' }} />
                                                    </IconButton>
                                                </Tooltip>
                                            </div>
                                        </StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>
                                            <strong>Estado Solicitud</strong>
                                            <Tooltip title="Filtrar por Estado" arrow>
                                                <IconButton onClick={(event) => handleFilterClick(event, 'statusSolicitud')}>
                                                    <FilterListIcon style={{ color: 'white' }} />
                                                </IconButton>
                                            </Tooltip>
                                        </StyledTableCell>
                                    </StyledTableRow>
                                </TableHead>

                                <Popover
                                    id={id}
                                    open={open}
                                    anchorEl={anchorEl}
                                    onClose={handleFilterClose}
                                    anchorOrigin={{
                                        vertical: 'bottom',
                                        horizontal: 'center',
                                    }}
                                    transformOrigin={{
                                        vertical: 'top',
                                        horizontal: 'center',
                                    }}
                                >
                                    {filterType === 'search' && (
                                        <TextField
                                            placeholder="Realizar Búsqueda"
                                            aria-label="Search"
                                            value={searchTerm}
                                            onChange={handleSearchChange}
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <SearchIcon />
                                                    </InputAdornment>
                                                ),
                                            }}
                                        />
                                    )}
                                    {filterType === 'loanType' && (
                                        <FormControl>
                                            <Select
                                                value={loanType}
                                                onChange={handleLoanTypeChange}
                                                displayEmpty
                                            >
                                                <MenuItem value=""><em>Todos los tipos</em></MenuItem>
                                                <MenuItem value="Sin Aval">Sin Aval</MenuItem>
                                                <MenuItem value="Con Aval">Con Aval</MenuItem>
                                                <MenuItem value="Consolidacion de Deuda">Consolidacion de Deuda</MenuItem>
                                                <MenuItem value="Alivio de Deuda">Alivio de Deuda</MenuItem>
                                                <MenuItem value="Refinanciamiento">Refinanciamiento</MenuItem>
                                                <MenuItem value="Hipotecario">Hipotecario</MenuItem>
                                            </Select>
                                        </FormControl>
                                    )}
                                    {filterType === 'status' && (
                                        <FormControl>
                                            <Select
                                                value={statusFilter}
                                                onChange={handleStatusChange}
                                                displayEmpty
                                            >
                                                <MenuItem value=""><em>Todos</em></MenuItem>
                                                <MenuItem value="Sin Asignar">Sin Asignar</MenuItem>
                                                <MenuItem value="Asignado">Asignado</MenuItem>
                                            </Select>
                                        </FormControl>
                                    )}
                                    {filterType === 'statusSolicitud' && (
                                        <FormControl>
                                            <Select
                                                value={statusSolicitudFilter}
                                                onChange={handleStatusSolicitudChange}
                                                displayEmpty
                                            >
                                                <MenuItem value=""><em>Todos</em></MenuItem>
                                                <MenuItem value="Sin Revisar">Sin Revisar</MenuItem>
                                                <MenuItem value="Pre Aprobado">Pre Aprobado</MenuItem>
                                                <MenuItem value="Pre Aprobado Sujeto A Cambios">Pre Aprobado Sujeto A Cambios</MenuItem>
                                                <MenuItem value="Rechazado">Rechazado</MenuItem>
                                            </Select>
                                        </FormControl>
                                    )}
                                </Popover>
                                <TableBody>
                                    {filteredRows.length > 0 ? (
                                        (rowsPerPage > 0
                                            ? filteredRows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                            : filteredRows
                                        ).map((row) => (
                                            <StyledTableRow key={row.SolicitudID}>
                                                <StyledTableCell style={{ textAlign: 'center' }}>
                                                    {row.SolicitudID !== null && row.SolicitudID !== undefined && row.SolicitudID}
                                                </StyledTableCell>
                                                <StyledTableCell>
                                                    {row.NumeroSolicitud !== null && row.NumeroSolicitud !== undefined && row.NumeroSolicitud}
                                                </StyledTableCell>
                                                <StyledTableCell>
                                                    {row.solicitante && row.solicitante[0] && row.solicitante[0].Nombres && row.solicitante[0].Apellidos && `${row.solicitante[0].Nombres} ${row.solicitante[0].Apellidos}`}
                                                </StyledTableCell>
                                                <StyledTableCell>
                                                    {row.TipoPrestamo !== null && row.TipoPrestamo !== undefined && row.TipoPrestamo}
                                                </StyledTableCell>
                                                <StyledTableCell>
                                                    {row.FechaSolicitud !== null && row.FechaSolicitud !== undefined && row.FechaSolicitud.slice(0, 10)}
                                                </StyledTableCell>
                                                <StyledTableCell>
                                                    {row.asignado !== null ? 'Asignado' : 'Sin Asignar'}
                                                </StyledTableCell>
                                                <StyledTableCell style={{ textAlign: 'center' }}>
                                                    <span
                                                        style={{
                                                            backgroundColor:
                                                                row.aprobado === 1 ? '#C6F7D0' :
                                                                    row.aprobado === 2 ? '#f0b70c' :
                                                                        row.aprobado === 3 ? '#FE0000' :
                                                                            row.aprobado === 5 ? '#C6F7D0' :
                                                                                row.aprobado === 6 ? '#FE0000' :
                                                                                    row.aprobado === 7 ? '#C6F7D0' : '#fcfc00',
                                                            borderRadius: 10,
                                                            color: row.aprobado === 3 ? 'white' : 'black',
                                                            padding: 10,
                                                            width: '150px',  // Establece el ancho fijo deseado
                                                            display: 'inline-block',  // Asegura que el ancho se aplique correctamente
                                                        }}
                                                    >
                                                        {row.aprobado === 1 ? 'Pre Aprobado' :
                                                            row.aprobado === 2 ? 'Pre Aprobado Sujeto A Cambios' :
                                                                row.aprobado === 3 ? 'Rechazado' :
                                                                    row.aprobado === 5 ? 'Aprobado' :
                                                                        row.aprobado === 6 ? 'Rechazado' :
                                                                            row.aprobado === 7 ? 'Aprobado Sujeto A Cambios' :
                                                                                'Sin Revisar'}
                                                    </span>
                                                </StyledTableCell>

                                            </StyledTableRow>
                                        ))
                                    ) : (
                                        <StyledTableRow>
                                            <StyledTableCell colSpan={8} style={{ textAlign: 'center' }}>
                                                No se encontraron datos
                                            </StyledTableCell>
                                        </StyledTableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        {filteredRows.length > 0 && (
                            // El componente de paginación ya usa `filteredRows.length` dinámicamente
                            <TablePagination
                                rowsPerPageOptions={[5, 10, 25]}
                                component="div"
                                count={filteredRows.length} // Longitud dinámica basada en la búsqueda
                                rowsPerPage={rowsPerPage}
                                page={page}
                                onPageChange={handleChangePage}
                                labelRowsPerPage={"Filas por página"}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                            />
                        )}
                    </div>
                </>
            )}
        </div>
    );
}

export default EstadosPreanalisis;